import styled from 'styled-components';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_gradient_B};
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: ${({ theme: { reference } }) => reference.dimension_10};
  opacity: 0.5px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${pxToRem(20)};
  }
`;

export const SpinnerContainer = styled(FlexContainer)`
  height: 100%;
`;

export const ItemList = styled.li`
  display: flex;
  align-items: center;
  padding: 0px;
  width: 100%;
  height: ${pxToRem(20)};
  margin-bottom: ${pxToRem(15)};
`;

export const ItemIcon = styled.div`
  display: flex;
  padding: ${pxToRem(10)};
`;

export const DescriptionBenefitsContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  width: ${pxToRem(400)};
  margin-top: ${pxToRem(20)};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const AmountContent = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonsContainer = styled(FlexContainer)`
  max-width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const InputContainer = styled(FlexContainer)`
  max-width: 358px;
  padding: ${({ theme: { reference } }) => `0 ${reference.dimension_16}`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ButtonsActions = styled(Buttons.Classic)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
`;

export const Link = styled.a`
  text-decoration: underline;
`;

export const Price = styled(Text)`
  text-decoration: line-through;
  color: ${({ theme: { colors } }) => colors.danger_500};
`;
